/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
export default function SmsSetupWizardController($scope, $timeout, $translate, $filter, $mdDialog, $q, types, toast, agDeviceService, deviceService, userService, agTypes,
                                                 gatewayId, subsys, subsysConfig, subsysStatus, ttyPorts, userMode, $log, ctx) {

    var vm = this;

    vm.agTypes = agTypes;
    vm.ctx = ctx;
    vm.step = "step1";
    vm.gatewayId = gatewayId;
    vm.subsys = subsys;
    vm.subsysConfig = subsysConfig;
    vm.subsysStatus = subsysStatus;
    vm.ttyPorts = ttyPorts;
    vm.userMode = userMode;

    vm.netControllersIds = [];
    vm.netControllersSerials = [];
    vm.netControllers = [];

    vm.skipConfiguring = false;
    let userDetails = userService.getCurrentUserDetails();

    vm.goToNextStep = goToNextStep;
    vm.detectNetControllers = detectNetControllers;
    vm.redetectNetControllers = redetectNetControllers;
    vm.reconfigureNc = reconfigureNc;
    vm.reconfigureNcAll = reconfigureNcAll;
    vm.checkConfiguringStatus = checkConfiguringStatus;
    vm.checkDoneStatus = checkDoneStatus;
    vm.checkAllCablesCreated = checkAllCablesCreated;
    vm.addNonexistentDevices = addNonexistentDevices;
    vm.finishSetupWizard = finishSetupWizard;
    vm.cancel = cancel;
    
    vm.netControllersIds = [];
    vm.netControllers = [];

    function goToNextStep(step) {
        if (step === "step1") {
            
            vm.netControllersIds = [];
            vm.netControllers = [];
            vm.step = step;
        } else if (step === 'step2') {
            goToNextStep('step3')
        } else if (step === "step3") {
            if (vm.netControllersIds.length) {
                vm.step = step;
            } else {
                //redetectNetControllers()
                vm.mode = 'STARTING'
                restartSubsysInConfigMode().then(
                    (response) => {
                        let comparing = angular.equals(vm.subsysConfig, response.result);
                        if (!comparing) {
                            toast.showError($translate.instant('ag.sms.config-sync-error'), angular.element('.ag-sms-setup-wizard'), 'bottom left');
                        }
                        vm.step = step;
                        //vm.netControllersIds = [];
                        //vm.netControllersSerials = [];
                        //redetectNetControllers();
                        /*$timeout(() => {
                            detectNetControllersAfterRestart();
                        }, 20000);*/
                    },
                    (err) => {
                        $log.info('failed to restart in config mode', err)
                        vm.mode = 'ERROR'
                        vm.rpcLoading = false;
                    }
                );
            }
        } /*else if (step == "step3") {
            if (vm.netControllers.length) {
                vm.step = step;
            } else {
                //fetchNetControllersInfo();
            }
        }*/ else if (step === "step4") {
            createDeviceListInfo();
        }
    }

    // function __checkConfigStatus () {
    //     let state = vm.configState
    //     let ncs = state.netcontrollers[vm.serialPort] || {}
    //     let shouldCheck = false
    //     for (var k in ncs) {
    //         if (ncs[k].status == 'CONFIGURING') {
    //             shouldCheck = true;
    //         }
    //     }
    //     if (shouldCheck) {
    //         sendTwoWayRpc('check_config_status', {}, vm.subsys.id.id, 10000)
    //     }
    //     $timeout(function () {
    //         checkConfigStatus();
    //     }, 10000);
    // }

    vm.configState = {netcontrollers: {}}

    function onConfigStateUpdated () {
        let state = vm.configState
        $log.info(state)
        vm.netControllers = []
        vm.netControllersIds = []
        vm.netControllersSerials = []
        if (state.status === 'WAITING') {
            vm.rpcLoading = false;
        } else {
            // DO NOT SET RPC LOADING HERE
            //vm.rpcLoading = true;
        }
        let netcontrollers = state.netcontrollers || {}
        let ncs = netcontrollers[vm.serialPort] || {}
        for (var k in ncs) {
            let net = ncs[k]
            
            let status = net.status
            if (net.cableCount < 0 && net.status !== 'CONFIGURING') {
                continue
            }

            if (net.status === 'WAITING') {
                status = vm.agTypes.netControllerStatus.waiting;
            } else if (net.status === 'DONE') {
                status = vm.agTypes.netControllerStatus.done;
            } else if (net.status === 'CONFIGURING') {
                status = vm.agTypes.netControllerStatus.configuring
            } 
            vm.netControllersIds.push(net.address);
            vm.netControllersSerials.push(net.serial);
            var netController = {
                id: net.address,
                serial: net.serial,
                status: status,
                cablesCount: net.cableCount + Math.max(0, net.rhsCableCount || 0, net.co2CableCount || 0),
                cablesList: (net.lineNumbers || []).concat(net.rhsLineNumbers || []).concat(net.co2LineNumbers || []),
                tempCablesCount: net.cableCount || 0,
                tempCablesList: net.lineNumbers || [],
                rhsCableCount: net.rhsCableCount || 0,
                rhsCablesList: net.rhsLineNumbers || [],
                co2CableCount: net.co2CableCount || 0,
                co2CablesList: net.co2LineNumbers || []
            }
            vm.netControllers.push(netController);
        }
    }

    vm.configStateAttr = {
        name: "configState", 
        label: "Config State"
    };
    vm.modeAttr = {
        name: "mode", 
        label: "Mode"
    };
    vm.mode = null
    function onDataUpdated(subscription) {
        for (var item of subscription.data) {
            if (item.data.length === 0) {
                continue
            }
            if (item.dataKey.name === vm.configStateAttr.name) {
                let latestValue = item.data.slice(-1)[0][1]
                vm.configState = angular.fromJson(latestValue)
                onConfigStateUpdated()
            } else if (item.dataKey.name === vm.modeAttr.name) {
                vm.mode = item.data.slice(-1)[0][1]
            }
        }
        $scope.$apply()
    }
    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }
    vm.subscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: (subscription) => {
                subscription
                //$log.info('DATA LOADING', subscription.loadingData);
            }
        },
        useDashboardTimewindow: false
    };

    vm.canReconfigure = function (netController) {
        if (vm.finishSetup) return false;
        if (netController.status === 'NO_RESPONSE') return false;
        return netController.status !== vm.agTypes.netControllerStatus.configuring
    }
    vm.canPing = function (netController) {
        return netController.status !== vm.agTypes.netControllerStatus.configuring && !netController._pinging
    }
    vm.canRemove = function (netController) {
        return !netController._removing && (
                netController.status === vm.agTypes.netControllerStatus.configuring ||
                netController.status === 'NO_RESPONSE')
    }

    vm.pingNc = function (netController) {
        netController._pinging = true
        sendTwoWayRpc('ping_nc_config', {address: netController.id}, vm.subsys.id.id, 15000).then(
            () => {
                netController._pinging = false
            },
            () => {
                netController._pinging = false
            }
        )
    }
    vm.removeNc = function (netController) {
        netController.cableCount = -1
        netController._removing = true
        sendTwoWayRpc('remove_nc_config', {address: netController.id}, vm.subsys.id.id, 6000).then(
            () => {
                netController._removing = false
            },
            () => {
                netController._removing = false
            }
        )
    }

    function startup () {
        let sms = vm.subsys
        
        var cropLevelSubscriptionsInfo = [{
            type: types.datasourceType.entity,
            entityType: types.entityType.device,
            entityId: sms.id.id,
            entityName: sms.name,
            timeseries: [],
            attributes: [vm.configStateAttr, vm.modeAttr]
        }];

        vm.ctx.subscriptionApi.createSubscriptionFromInfo(
            types.widgetType.timeseries.value, cropLevelSubscriptionsInfo, vm.subscriptionOptions, false, true).then(
            (subscription) => {
                vm.subscription = subscription;
            }
        )
        //checkConfigStatus()
    }
    startup();

    function cancel() {
        restartSubsysInNormalMode().then(
            (response) => {
                let comparing = angular.equals(vm.subsysConfig, response.result);
                if (!comparing) {
                    toast.showError($translate.instant('ag.sms.config-sync-error'), angular.element('.ag-sms-setup-wizard'), 'bottom left');
                }
                vm.rpcLoading = false;
                vm.finishSetup = false;
                $mdDialog.cancel();
            },
            () => {
                vm.finishSetup = false;
                vm.rpcLoading = false;
            }
        );
        
    }

    function reconfigureNc (netController) {
        reconfigureNetcontrollers([netController])
    }

    function reconfigureNetcontrollers (netControllers) {
        // TODO: use a "sending status" until response has been received
        let adrs = netControllers.filter(
            net => net.status !== vm.agTypes.netControllerStatus.configuring
        ).map(net => {
            net.status = vm.agTypes.netControllerStatus.configuring;
            return net.id
        })
        sendTwoWayRpc('reconfigure_multi', {adrs: adrs}, vm.subsys.id.id, 10000).then(
            () => {
            },
            () => {
                // TODO: revert back from configuration status
            }
        )
    }

    // function __reconfigureNc(netController, isAll) {
    //     vm.rpcLoading = true;
    //
    //     sendTwoWayRpc('reconfigure', {address: netController.id}, vm.subsys.id.id, 10000).then(
    //         () => {
    //             vm.rpcLoading = false;
    //             netController.status = vm.agTypes.netControllerStatus.configuring;
    //             if (!isAll) {
    //                 toast.showSuccess($translate.instant('ag.sms.nc-attention-message'), 0, angular.element('.ag-sms-setup-wizard'), 'bottom left');
    //             }
    //             checkConfiguringFinish(netController);
    //         },
    //         () => {
    //             vm.rpcLoading = false;
    //         }
    //     );
    // }

    function reconfigureNcAll() {
        toast.showSuccess($translate.instant('ag.sms.nc-attention-message'), 0, angular.element('.ag-sms-setup-wizard'), 'bottom left');
        reconfigureNetcontrollers(vm.netControllers);
    }

    function checkConfiguringStatus(netControllers) {
        var configuringResult = $filter('filter')(vm.netControllers, {status: vm.agTypes.netControllerStatus.configuring}, true);
        if (netControllers && netControllers.length) {
            return (configuringResult.length === vm.netControllers.length);
        }
        return !!configuringResult.length;
    }

    function checkDoneStatus() {
        if (vm.skipConfiguring) {
            return true;
        }
        var doneResult = $filter('filter')(vm.netControllers, {status: vm.agTypes.netControllerStatus.done}, true);
        return !!doneResult.length;
    }

    function checkAllCablesCreated() {
        var match = false;
        for (var i = 0; i < vm.allCables.length; i++) {
            if (!vm.allCables[i].createdTime) {
                match = true;
                break;
            }
        }
        return match;
    }

    // function __checkConfiguringFinish(netController) {
    //     agDeviceService.sendGatewayRpcCommand('ping_nc', {address: netController.id}, vm.subsys.id.id, 10000).then(
    //         (pingResponseBody) => {
    //             if (pingResponseBody.result == -1) {
    //                 $timeout(function () {
    //                     checkConfiguringFinish(netController);
    //                 }, 60000);
    //             } else {
    //                 netController.cablesCount = pingResponseBody.result;
    //                 sendTwoWayRpc('get_config', {address: netController.id}, vm.subsys.id.id, 3000).then(
    //                     (responseBody) => {
    //                         netController.cablesList = responseBody.result;
    //                         netController.status = vm.agTypes.netControllerStatus.done;
    //                     }
    //                 );
    //             }
    //         }
    //     );
    // }

    // function detectNetControllersAfterRestart() {
    //     agDeviceService.sendGatewayRpcCommand('ping', {}, vm.subsys.id.id, 3000).then(
    //         () => {
    //             vm.errorCounter = 0;
    //             detectNetControllers(1);
    //         },
    //         () => {
    //             $timeout(detectNetControllersAfterRestart, 1000);
    //         }
    //     );
    // }

    function detectNetControllers(idCounter) {
        agDeviceService.sendGatewayRpcCommand('get_serial', {address: idCounter}, vm.subsys.id.id, 10000).then(
            (responseBody) => {
                if (responseBody.status !== 'error') {
                    vm.errorCounter = 0;
                    vm.netControllersIds.push(idCounter);
                    vm.netControllersSerials.push(responseBody.result.serial);
                    detectNetControllers(++idCounter);
                } else {
                    if (++vm.errorCounter === 2) {
                        vm.rpcLoading = false;
                    } else {
                        detectNetControllers(++idCounter);
                    }
                }
            },
            () => {
                if (++vm.errorCounter === 2) {
                    vm.rpcLoading = false;
                } else {
                    detectNetControllers(++idCounter);
                }
            }
        );
    }

    function redetectNetControllers() {
        vm.rpcLoading = true;
        /*vm.errorCounter = 0;
        vm.netControllers = [];
        vm.netControllersIds = [];
        vm.netControllersSerials = [];
        */
        agDeviceService.sendGatewayRpcCommand('discover_nc', {}, vm.subsys.id.id, 10000)
        //detectNetControllers(1);
    }

    // function fetchNetControllersInfo() {
    //     vm.rpcLoading = true;
    //     vm.netControllers = [];
    //     var fetchPingTasks = [];
    //     var fetchConfigTasks = [];
    //     if (vm.netControllersIds.length) {
    //         for (var i = 0; i < vm.netControllersIds.length; i++) {
    //             var netController = {
    //                 id: vm.netControllersIds[i],
    //                 serial: vm.netControllersSerials[i]
    //             }
    //             vm.netControllers.push(netController);
    //             fetchPingTasks.push(sendTwoWayRpc('ping_nc', {address: netController.id}, vm.subsys.id.id, 3000));
    //         }
    //         $q.all(fetchPingTasks).then(
    //             (pingResponseBodies) => {
    //                 for (i = 0; i < pingResponseBodies.length; i++) {
    //                     vm.netControllers[i].cablesCount = pingResponseBodies[i].result;
    //                     vm.netControllers[i].status = vm.agTypes.netControllerStatus.waiting;
    //                     if (pingResponseBodies[i].result == 0) {
    //                         fetchConfigTasks.push($q.when({status: "ok", result: [0]}));
    //                     } else {
    //                         fetchConfigTasks.push(sendTwoWayRpc('get_config', {address: vm.netControllers[i].id}, vm.subsys.id.id, 20000));
    //                     }
    //                 }
    //                 $q.all(fetchConfigTasks).then(
    //                     (configResponseBodies) => {
    //                         for (i = 0; i < configResponseBodies.length; i++) {
    //                             vm.netControllers[i].cablesList = configResponseBodies[i].result;
    //                         }
    //                         vm.rpcLoading = false;
    //                         vm.step = "step3";
    //                     },
    //                     () => {
    //                         vm.rpcLoading = false;
    //                     }
    //                 );
    //             },
    //             () => {
    //                 vm.rpcLoading = false;
    //             }
    //         );
    //     }
    // }

    function restartSubsysInConfigMode() {
        var deferred = $q.defer();
        vm.rpcLoading = true;
        vm.subsysConfig.hardware_config.serial_port = vm.serialPort;
        vm.subsysConfig.controller_config.config_mode = true;
        agDeviceService.saveSubsysConfig(vm.subsys, angular.toJson(vm.subsysConfig)).then(
            () => {
                subsysFetch().then(
                    (response) => {
                        deferred.resolve(response);
                    },
                    () => {
                        $log.info('failed subsysFetch() config')
                        deferred.reject();
                    }
                );
            },
            () => {
                $log.info('failed to save subsys config')
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function restartSubsysInNormalMode() {
        var deferred = $q.defer();
        vm.finishSetup = true;
        vm.rpcLoading = true;
        
        vm.subsysConfig.controller_config.config_mode = false;
        agDeviceService.saveSubsysConfig(vm.subsys, angular.toJson(vm.subsysConfig)).then(
            () => {
                subsysFetch().then(
                    (response) => {
                        deferred.resolve(response);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function finishSetupWizard() {
        vm.subsysConfig.hardware_config.netcontroller_ids = [];
        for (let i = 0; i < vm.netControllers.length; i++) {
            vm.subsysConfig.hardware_config.netcontroller_ids.push(vm.netControllers[i].id);
        }
        restartSubsysInNormalMode().then(
            (response) => {
                let comparing = angular.equals(vm.subsysConfig, response.result);
                if (!comparing) {
                    toast.showError($translate.instant('ag.sms.config-sync-error'), angular.element('.ag-sms-setup-wizard'), 'bottom left');
                }
                vm.rpcLoading = false;
                vm.finishSetup = false;
                $mdDialog.hide();
            },
            () => {
                vm.finishSetup = false;
                vm.rpcLoading = false;
            }
        );
    }

    function subsysFetch() {
        var deferred = $q.defer();
        sendTwoWayRpc('subsys_fetch', {subsysid: vm.subsysConfig.id}, vm.gatewayId, 10000).then(
            (responseBody) => {
                processRpcResponse(responseBody).then(
                    () => {
                        deferred.resolve(responseBody);
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function addNonexistentDevices() {
        vm.rpcLoading = true;
        createNonexistentDevices().then(
            () => {
                createDeviceListInfo();
            }
        );
    }

    function createNonexistentDevices() {
        var deferred = $q.defer();
        var cables = [];
        var cablesTasks = [];

        for (var i = 0; i < vm.allCables.length; i++) {
            if (!vm.allCables[i].createdTime) {
                vm.allCables[i].length = vm.cableLength;
                vm.allCables[i].sensorDistance = vm.sensorDistance;
                vm.allCables[i].firstSensorOffset = vm.firstSensorOffset;
                cables.push(vm.allCables[i]);
            }
        }
        for (i = 0; i < cables.length; i++) {
            cablesTasks.push(agDeviceService.saveDevice(cables[i], (error) => {
                toast.showError(error)
            }));
        }
        $q.all(cablesTasks).then(
            () => {
                deferred.resolve();
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    function createDeviceListInfo() {
        vm.rpcLoading = true;
        vm.finishSetup = true;
        var foundedCables = createFoundedDevices();

        getExistingDevicesByNcSerials().then(
            (existingResponseBody) => {
                vm.allCables = angular.copy(foundedCables);
                for (var i = 0; i < existingResponseBody.length; i++) {
                    var match = $filter('filter')(foundedCables, {name: existingResponseBody[i].name}, true);
                    if (match.length) {
                        for (var j = 0; j < vm.allCables.length; j++) {
                            if(vm.allCables[j].name === existingResponseBody[i].name) {
                                existingResponseBody[i].found = true;
                                vm.allCables[j] = existingResponseBody[i];
                            }
                        }
                    } else {
                        match = $filter('filter')(vm.allCables, {name: existingResponseBody[i].name}, true);
                        if(!match.length) {
                            vm.allCables.push(existingResponseBody[i]);
                        }
                    }
                }
                vm.allCables = $filter('orderBy')(vm.allCables, "name");
                vm.rpcLoading = false;
                vm.finishSetup = false;
                vm.step = "step4";

            },
            () => {
                vm.rpcLoading = false;
                vm.finishSetup = false;
            }
        );
    }

    function createFoundedDevices() {
        var result = [];
        for (var i = 0; i < vm.netControllers.length; i++) {
            if (vm.netControllers[i].cablesList && vm.netControllers[i].cablesList.length) {
                for (let j = 0; j < vm.netControllers[i].tempCablesList.length; j++) {
                    let lineNumString = pad(vm.netControllers[i].tempCablesList[j], 3);
                    let name = agTypes.deviceNamePrefix.temperatureSensorLines + vm.netControllers[i].serial + agTypes.deviceNameSuffix.temperatureSensorLines + lineNumString;
                    var temperatureCable = {
                        name: name,
                        type: agTypes.deviceType.temperatureSensorLines,
                        found: true
                    }
                    result.push(temperatureCable);
                }
                for (let j = 0; j < vm.netControllers[i].rhsCablesList.length; j++) {
                    let lineNumString = pad(vm.netControllers[i].rhsCablesList[j], 3);
                    let name = agTypes.deviceNamePrefix.moistureSensorLines + vm.netControllers[i].serial + agTypes.deviceNameSuffix.moistureSensorLines + lineNumString;
                    var rhsCable = {
                        name: name,
                        type: agTypes.deviceType.moistureSensorLines,
                        found: true
                    }
                    result.push(rhsCable);
                }
                for (let j = 0; j < vm.netControllers[i].co2CablesList.length; j++) {
                    let lineNumString = pad(vm.netControllers[i].co2CablesList[j], 3);
                    let name = agTypes.deviceNamePrefix.co2SensorLines + vm.netControllers[i].serial + agTypes.deviceNameSuffix.co2SensorLines + lineNumString;
                    var co2Cable = {
                        name: name,
                        type: agTypes.deviceType.co2SensorLines,
                        found: true
                    }
                    result.push(co2Cable);
                }
            }
        }
        return result;
    }

    function getExistingDevicesByNcSerials() {
        var deferred = $q.defer();
        var getDevicesTasks = [];

        for (let i = 0; i < vm.netControllers.length; i++) {
            let textSearch = vm.agTypes.deviceNamePrefix.temperatureSensorLines + vm.netControllers[i].serial;
            if (userDetails.authority === "TENANT_ADMIN") {
                getDevicesTasks.push(deviceService.getTenantDevices({limit: 999, textSearch: textSearch}, null, null, agTypes.deviceType.temperatureSensorLines));
            } else if (userDetails.authority === "CUSTOMER_USER") {
                getDevicesTasks.push(deviceService.getCustomerDevices(userDetails.customerId.id, {limit: 999, textSearch: textSearch}, null, null, agTypes.deviceType.temperatureSensorLines));
            }
        }
        for (let i = 0; i < vm.netControllers.length; i++) {
            let textSearch = vm.agTypes.deviceNamePrefix.moistureSensorLines + vm.netControllers[i].serial;
            if (userDetails.authority === "TENANT_ADMIN") {
                getDevicesTasks.push(deviceService.getTenantDevices({limit: 999, textSearch: textSearch}, null, null, agTypes.deviceType.moistureSensorLines));
            } else if (userDetails.authority === "CUSTOMER_USER") {
                getDevicesTasks.push(deviceService.getCustomerDevices(userDetails.customerId.id, {limit: 999, textSearch: textSearch}, null, null, agTypes.deviceType.moistureSensorLines));
            }
        }
        for (let i = 0; i < vm.netControllers.length; i++) {
            let textSearch = vm.agTypes.deviceNamePrefix.co2SensorLines + vm.netControllers[i].serial;
            if (userDetails.authority === "TENANT_ADMIN") {
                getDevicesTasks.push(deviceService.getTenantDevices({limit: 999, textSearch: textSearch}, null, null, agTypes.deviceType.co2SensorLines));
            } else if (userDetails.authority === "CUSTOMER_USER") {
                getDevicesTasks.push(deviceService.getCustomerDevices(userDetails.customerId.id, {limit: 999, textSearch: textSearch}, null, null, agTypes.deviceType.co2SensorLines));
            }
        }

        $q.all(getDevicesTasks).then(
            (responseBody) => {
                var result = [];
                for (let i = 0; i < responseBody.length; i++) {
                    if (responseBody[i].data) {
                        result = result.concat(responseBody[i].data);
                    }
                }
                deferred.resolve(result);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function processRpcResponse(responseBody) {
        return agDeviceService.processGatewayRpcResponse(responseBody, (error) => {
            showRpcError(error);
        });
    }

    function sendTwoWayRpc(method, params, gatewayId, timeout) {
        if (!gatewayId) {
            gatewayId = vm.gatewayId;
        }
        return agDeviceService.sendGatewayRpcCommand(method, params, gatewayId, timeout, (error) => {
            showRpcError(error);
        });
    }

    function showRpcError(error) {
        toast.showError(error, angular.element('.ag-sms-setup-wizard'), 'bottom left');
    }

    function pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    $scope.$on('$destroy', () => {
        toast.hide();
    });
}